import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50349504")

_pushScopeId("data-v-50349504")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "right-container flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "一斉メッセージ", -1)
const _hoisted_4 = { class: "flex-grow flex flex-col items-start bg-primary-100 overflow-y-scroll overflow-x-scroll px-12 pt-12" }
const _hoisted_5 = { class: "panel-container rounded-md bg-white pb-2 mb-16 lg:mb-8" }
const _hoisted_6 = { class: "sticky top-0 -left-4 flex flex-row gap-4 pt-3 px-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" ひとりずつ登録 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" CSV一括登録 ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 生徒情報を編集 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Google連携 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Microsoft連携 ")
const _hoisted_14 = /*#__PURE__*/_createVNode("p", null, "全生徒エクスポート", -1)
const _hoisted_15 = {
  key: 2,
  class: "table-header-color text-gray-500 text-xs hidden lg:block"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" ・＊は、「みんがく学習室」のみの集計結果です。（＊のない項目はタイムキーパーなどを含めた全学習の集計）")
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" ・「学習中」はデータ更新時点の情報です。（🏠…学習室利用中、 ⏰…タイムキーパー利用中） ")
const _hoisted_19 = { class: "flex items-center space-x-2 px-4 py-2" }
const _hoisted_20 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-center w-5 h-5 bg-green-100 rounded-full" }, [
  /*#__PURE__*/_createVNode("svg", {
    class: "w-3 h-3 text-green-600",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
      "clip-rule": "evenodd"
    })
  ])
], -1)
const _hoisted_22 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_23 = {
  key: 1,
  class: "flex items-center space-x-2 text-red-500"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "text-sm font-medium" }, " 生徒情報の取得に失敗しました。「更新」ボタンから再試行してください。 ", -1)
const _hoisted_25 = {
  key: 2,
  class: "flex items-center space-x-2"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-center w-5 h-5" }, [
  /*#__PURE__*/_createVNode("svg", {
    class: "animate-spin w-4 h-4 text-blue-600",
    fill: "none",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      class: "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "4"
    }),
    /*#__PURE__*/_createVNode("path", {
      class: "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    })
  ])
], -1)
const _hoisted_27 = { class: "text-sm text-blue-600" }
const _hoisted_28 = {
  key: 0,
  class: "flex-1 bg-gray-200 rounded-full h-2 max-w-xs"
}
const _hoisted_29 = { class: "flex items-center sticky left-0" }
const _hoisted_30 = { class: "mr-2" }
const _hoisted_31 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 mr-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" })
], -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "教室", -1)
const _hoisted_33 = {
  key: 0,
  class: "list-none flex items-center w-full px-2 py-2 text-sm font-bold border-b"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("p", null, "教室", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 mr-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" })
], -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "学年", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("p", null, "学年", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 mr-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" })
], -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("span", null, "授業曜日", -1)
const _hoisted_40 = { class: "list-none flex items-center w-full px-2 py-2 mt-4 text-sm font-bold border-b" }
const _hoisted_41 = /*#__PURE__*/_createVNode("p", null, "授業曜日", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 ml-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M19 9l-7 7-7-7" })
], -1)
const _hoisted_43 = { class: "px-4 py-2 flex items-center" }
const _hoisted_44 = /*#__PURE__*/_createVNode("p", { class: "mr-1 text-xs text-gray-700" }, "開始", -1)
const _hoisted_45 = { class: "px-4 py-2 flex items-center" }
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { class: "mr-1 text-xs text-gray-700" }, "終了", -1)
const _hoisted_47 = { class: "flex justify-center" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" データ更新 ")
const _hoisted_49 = /*#__PURE__*/_createVNode("span", null, "表示項目を選択", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 ml-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M19 9l-7 7-7-7" })
], -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("p", null, "列", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("span", null, "表示・印刷順を設定", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 ml-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M19 9l-7 7-7-7" })
], -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("p", { class: "mb-1" }, "生徒表示順のキーを選択", -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("span", {
  class: "text-xs pl-4 mb-2",
  style: {"text-indent":"-1em"}
}, [
  /*#__PURE__*/_createTextVNode("※ 生徒一覧の初期表示の順とログイン情報印刷順に適応されます。"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("デフォルトでログインIDが設定されます。")
], -1)
const _hoisted_56 = { class: "flex justify-end" }
const _hoisted_57 = { class: "font-medium flex items-center gap-1" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" 降順にする ")
const _hoisted_59 = /*#__PURE__*/_createVNode("span", null, "更新", -1)
const _hoisted_60 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "生徒情報取得中...", -1)
const _hoisted_62 = { class: "hidden lg:flex justify-between items-center" }
const _hoisted_63 = { class: "flex items-center" }
const _hoisted_64 = { class: "mr-6 text-gray-500 text-sm" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" みんがくログイン情報印刷 ")
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" スクールAIログイン情報印刷 ")
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" 学習データを出力 ")
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" 生徒データを出力 ")
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" TODOデータを出力 ")
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" 成長ジャーナルデータを出力 ")
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" 学習カード情報を出力 ")
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" アプリ作成を許可 ")
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" アプリ作成を禁止 ")
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" メッセージ送信を許可 ")
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" メッセージ送信を禁止 ")
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 生徒をグループ化 ")
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" 学習予定を追加 ")
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" メッセージ送信 ")
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" 休会に変更 ")
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" 休会を解除 ")
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" 生徒削除 ")
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" アプリ作成を許可 ")
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" アプリ作成を禁止 ")
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" メッセージ送信を許可 ")
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" メッセージ送信を禁止 ")
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" 学年を上げる ")
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" 学年を下げる ")
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" みんがく帳票を印刷 ")
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" スクールAI帳票を印刷 ")
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" 成長ジャーナルデータを出力 ")
const _hoisted_91 = {
  key: 1,
  class: "flex"
}
const _hoisted_92 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_93 = { class: "flex-grow flex items-start justify-center bg-primary-100 overflow-y-auto px-4 pt-12" }
const _hoisted_94 = { class: "w-full max-w-2xl rounded-md bg-white px-6 py-10 text-center shadow-sm" }
const _hoisted_95 = /*#__PURE__*/_createVNode("h1", { class: "text-xl font-bold text-gray-800" }, " 生徒一覧画面が移動しました ", -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("p", { class: "mt-4 text-gray-600 leading-7" }, [
  /*#__PURE__*/_createTextVNode(" 生徒の確認・作成・編集・CSV一括登録は、"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" スクールAIの生徒情報画面から行えます。 ")
], -1)
const _hoisted_97 = { class: "mt-8 flex justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_dropdown_item = _resolveComponent("m-dropdown-item")
  const _component_m_action_dropdown = _resolveComponent("m-action-dropdown")
  const _component_m_table_condition_item = _resolveComponent("m-table-condition-item")
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_MLoadingIcon = _resolveComponent("MLoadingIcon")
  const _component_m_table = _resolveComponent("m-table")
  const _component_m_s_add_modal = _resolveComponent("m-s-add-modal")
  const _component_ms_send_modal = _resolveComponent("ms-send-modal")
  const _component_ms_add_group_modal = _resolveComponent("ms-add-group-modal")
  const _component_ms_reserve_modal = _resolveComponent("ms-reserve-modal")
  const _component_ms_csv_update_modal = _resolveComponent("ms-csv-update-modal")

  return (_ctx.showsStudentList)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_MNavBar),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_MHeaderPanel, {
              title: "生徒情報",
              breadcrumbs: [],
              tabs: _ctx.tabs,
              "current-tab-index": _ctx.currentTabIndex
            }, {
              actions: _withId(() => [
                _createVNode(_component_m_button, {
                  color: "secondary-500",
                  "hover-color": "secondary-600",
                  outline: "",
                  onClick: _ctx.showSendModal
                }, {
                  default: _withId(() => [
                    _createVNode(_component_m_icon, {
                      type: "send",
                      class: "mr-2 transform rotate-90 z-0"
                    }),
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["tabs", "current-tab-index"]),
            _createVNode("main", _hoisted_4, [
              _createVNode("section", _hoisted_5, [
                _createVNode("div", {
                  class: ["table-header-color w-full sticky flex items-start -top-12", [_ctx.modifyStudentListShowing ? 'z-30' : 'z-20']]
                }, [
                  _createVNode("div", _hoisted_6, [
                    (_ctx.isAdminOfSchool)
                      ? (_openBlock(), _createBlock("div", _hoisted_7, [
                          _createVNode(_component_m_action_dropdown, {
                            title: "生徒を登録",
                            "condition-modal-showing": _ctx.isMConditionModalShowing,
                            "dropdown-direction": "down",
                            onOnModalOpened: _ctx.handleMultiDropDownOpened,
                            onOnModalClosed: _ctx.handleMultiDropDownClosed
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_m_dropdown_item, {
                                disabled: !_ctx.allStudentsFetched,
                                onClick: _ctx.startStudentRegistration
                              }, {
                                default: _withId(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]),
                              _createVNode(_component_m_dropdown_item, {
                                disabled: !_ctx.allStudentsFetched,
                                "has-border": false,
                                onClick: _ctx.openMultiStudentRegistrationModal
                              }, {
                                default: _withId(() => [
                                  _hoisted_9
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"])
                            ]),
                            _: 1
                          }, 8, ["condition-modal-showing", "onOnModalOpened", "onOnModalClosed"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isAdminOfSchool)
                      ? (_openBlock(), _createBlock("div", _hoisted_10, [
                          _createVNode(_component_m_action_dropdown, {
                            title: "まとめて編集",
                            "condition-modal-showing": _ctx.isMConditionModalShowing,
                            "dropdown-direction": "down",
                            onOnModalOpened: _ctx.handleMultiDropDownOpened,
                            onOnModalClosed: _ctx.handleMultiDropDownClosed
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_m_dropdown_item, {
                                disabled: !_ctx.allStudentsFetched,
                                onClick: _ctx.startEditingStudentsViaCsv
                              }, {
                                default: _withId(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]),
                              _createVNode(_component_m_dropdown_item, {
                                disabled: !_ctx.allStudentsFetched,
                                onClick: _ctx.openGoogleLinkageModal
                              }, {
                                default: _withId(() => [
                                  _hoisted_12
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]),
                              _createVNode(_component_m_dropdown_item, {
                                disabled: !_ctx.allStudentsFetched,
                                "has-border": false,
                                onClick: _ctx.openMicrosoftLinkageModal
                              }, {
                                default: _withId(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"])
                            ]),
                            _: 1
                          }, 8, ["condition-modal-showing", "onOnModalOpened", "onOnModalClosed"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_m_button, {
                      color: "primary-500",
                      "hover-color": "primary-600",
                      outline: "",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportStudent({ exportAll: true, onlyTemplate: false })))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_m_icon, {
                          type: "plus",
                          width: "4",
                          class: "mr-2"
                        }),
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode("input", {
                      ref: "fileInput",
                      type: "file",
                      hidden: "",
                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCsvFileInputForUpdate && _ctx.onCsvFileInputForUpdate(...args)))
                    }, null, 544),
                    _createVNode("input", {
                      ref: "fileInputForRegistration",
                      type: "file",
                      hidden: "",
                      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.registerStudentsViaCsv && _ctx.registerStudentsViaCsv(...args)))
                    }, null, 544),
                    _createVNode("input", {
                      ref: "fileInputForGoogleLinkage",
                      type: "file",
                      hidden: "",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCsvInputForExternalProviders($event, 'google')))
                    }, null, 544),
                    _createVNode("input", {
                      ref: "fileInputForMicrosoftLinkage",
                      type: "file",
                      hidden: "",
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onCsvInputForExternalProviders($event, 'microsoft')))
                    }, null, 544),
                    (!_ctx.isExclusiveSchoolAiUser)
                      ? (_openBlock(), _createBlock("div", _hoisted_15, [
                          _hoisted_16,
                          _hoisted_17,
                          _hoisted_18
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_19, [
                      (_ctx.allStudentsFetched)
                        ? (_openBlock(), _createBlock("div", _hoisted_20, [
                            _hoisted_21,
                            _createVNode("span", _hoisted_22, " 生徒取得完了: " + _toDisplayString(_ctx.baseDatas.length) + "人 ", 1)
                          ]))
                        : (_ctx.hasStudentFetchError)
                          ? (_openBlock(), _createBlock("div", _hoisted_23, [
                              _createVNode(_component_m_icon, {
                                type: "warning",
                                size: "5"
                              }),
                              _hoisted_24
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_25, [
                              _hoisted_26,
                              _createVNode("span", _hoisted_27, " 生徒取得中: " + _toDisplayString(_ctx.studentCount !== null
                        ? `${_ctx.countProgress} / ${_ctx.studentCount}人`
                        : "- / - 人"), 1),
                              (_ctx.studentCount !== null && _ctx.studentCount > 0)
                                ? (_openBlock(), _createBlock("div", _hoisted_28, [
                                    _createVNode("div", {
                                      class: "bg-blue-600 h-2 rounded-full transition-all duration-300 ease-out",
                                      style: 
                        `width: ${Math.min(
                          (_ctx.countProgress / _ctx.studentCount) * 100,
                          100
                        )}%`
                      
                                    }, null, 4)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                    ])
                  ])
                ], 2),
                _createVNode("div", {
                  class: ["relative flex items-center justify-between w-full table-header-color px-4 py-3", _ctx.dynamicClass]
                }, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", _hoisted_30, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchKeyword = $event)),
                        type: "search",
                        name: "searchStudent",
                        placeholder: "ユーザーネームで検索...",
                        class: "w-36 sm:w-52 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleSearchClick && _ctx.handleSearchClick(...args)))
                      }, null, 512), [
                        [_vModelText, _ctx.searchKeyword]
                      ])
                    ]),
                    _createVNode(_component_m_table_condition_item, {
                      active: 
                  _ctx.selectedClassroomIds.length !== _ctx.classrooms.length &&
                    !_ctx.isFilterDisabled
                ,
                      "prevent-click": _ctx.isFilterDisabled,
                      "display-alert-on-prevention": "",
                      alert: "全ての生徒情報の取得が完了するまでお待ちください。",
                      class: "hidden lg:block",
                      onShowModal: _ctx.handleShowModalChange
                    }, {
                      body: _withId(() => [
                        _createVNode("ul", null, [
                          (!_ctx.isAdmin)
                            ? (_openBlock(), _createBlock("li", _hoisted_33, [
                                _hoisted_34,
                                _createVNode("button", {
                                  class: "ml-20 bg-blue-400 hover:bg-blue-500 text-white p-1 rounded text-xs",
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.selectAllClassrooms && _ctx.selectAllClassrooms(...args)))
                                }, " 全選択 "),
                                _createVNode("button", {
                                  class: "ml-2 bg-gray-400 hover:bg-gray-500 text-white p-1 rounded text-xs",
                                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.deselectAllClassrooms && _ctx.deselectAllClassrooms(...args)))
                                }, " 全解除 ")
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.isAdmin)
                            ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.classrooms, (classroom) => {
                                return (_openBlock(), _createBlock("li", {
                                  key: classroom.ref.id,
                                  class: "list-none flex items-center w-full px-4 py-2 text-sm"
                                }, [
                                  _withDirectives(_createVNode("input", {
                                    id: classroom.ref.id,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedClassroomIds = $event)),
                                    type: "checkbox",
                                    name: classroom.ref.id,
                                    value: classroom.ref.id,
                                    class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                                  }, null, 8, ["id", "name", "value"]), [
                                    [_vModelCheckbox, _ctx.selectedClassroomIds]
                                  ]),
                                  _createVNode("label", {
                                    for: classroom.ref.id,
                                    class: "ml-2 block text-gray-700"
                                  }, _toDisplayString(classroom.data.name), 9, ["for"])
                                ]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      default: _withId(() => [
                        _hoisted_31,
                        _hoisted_32
                      ]),
                      _: 1
                    }, 8, ["active", "prevent-click", "onShowModal"]),
                    _createVNode(_component_m_table_condition_item, {
                      active: 
                  _ctx.selectedGrades.length !== _ctx.grades.length && !_ctx.isFilterDisabled
                ,
                      "prevent-click": _ctx.isFilterDisabled,
                      "display-alert-on-prevention": "",
                      alert: "全ての生徒情報の取得が完了するまでお待ちください。",
                      class: "hidden lg:block",
                      onShowModal: _ctx.handleShowModalChange
                    }, {
                      body: _withId(() => [
                        _createVNode("ul", null, [
                          _createVNode("li", {
                            class: ["list-none flex items-center w-full px-2 py-2 text-sm font-bold border-b", { 'mt-4': !_ctx.isAdmin }]
                          }, [
                            _hoisted_37,
                            _createVNode("button", {
                              class: "ml-20 bg-blue-400 hover:bg-blue-500 text-white p-1 rounded text-xs",
                              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.selectAllgrades && _ctx.selectAllgrades(...args)))
                            }, " 全選択 "),
                            _createVNode("button", {
                              class: "ml-2 bg-gray-400 hover:bg-gray-500 text-white p-1 rounded text-xs",
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.deselectAllgrades && _ctx.deselectAllgrades(...args)))
                            }, " 全解除 ")
                          ], 2),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.grades, (grade) => {
                            return (_openBlock(), _createBlock("li", {
                              key: grade.id,
                              class: "list-none flex items-center w-full px-4 py-2 text-sm"
                            }, [
                              _withDirectives(_createVNode("input", {
                                id: grade.id,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectedGrades = $event)),
                                type: "checkbox",
                                name: grade.id,
                                value: grade.value,
                                class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                              }, null, 8, ["id", "name", "value"]), [
                                [_vModelCheckbox, _ctx.selectedGrades]
                              ]),
                              _createVNode("label", {
                                for: grade.id,
                                class: "ml-2 block text-gray-700"
                              }, _toDisplayString(grade.value), 9, ["for"])
                            ]))
                          }), 128))
                        ])
                      ]),
                      default: _withId(() => [
                        _hoisted_35,
                        _hoisted_36
                      ]),
                      _: 1
                    }, 8, ["active", "prevent-click", "onShowModal"]),
                    _createVNode(_component_m_table_condition_item, {
                      active: 
                  _ctx.selectedDayOfTheWeek.length !== _ctx.dayOfTheWeeks.length &&
                    !_ctx.isFilterDisabled
                ,
                      "prevent-click": _ctx.isFilterDisabled,
                      "display-alert-on-prevention": "",
                      alert: "全ての生徒情報の取得が完了するまでお待ちください。",
                      class: "hidden lg:block",
                      onShowModal: _ctx.handleShowModalChange
                    }, {
                      body: _withId(() => [
                        _createVNode("ul", null, [
                          _createVNode("li", _hoisted_40, [
                            _hoisted_41,
                            _createVNode("button", {
                              class: "ml-12 bg-blue-400 hover:bg-blue-500 text-white p-1 rounded text-xs",
                              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.selectAlldayOfTheWeeks && _ctx.selectAlldayOfTheWeeks(...args)))
                            }, " 全選択 "),
                            _createVNode("button", {
                              class: "ml-2 bg-gray-400 hover:bg-gray-500 text-white p-1 rounded text-xs",
                              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.deselectAlldayOfTheWeeks && _ctx.deselectAlldayOfTheWeeks(...args)))
                            }, " 全解除 ")
                          ]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dayOfTheWeeks, (day) => {
                            return (_openBlock(), _createBlock("li", {
                              key: day.id,
                              class: "list-none flex items-center w-full px-4 py-2 text-sm"
                            }, [
                              _withDirectives(_createVNode("input", {
                                id: day.id,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectedDayOfTheWeek = $event)),
                                type: "checkbox",
                                name: day.id,
                                value: day.value,
                                class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                              }, null, 8, ["id", "name", "value"]), [
                                [_vModelCheckbox, _ctx.selectedDayOfTheWeek]
                              ]),
                              _createVNode("label", {
                                for: day.id,
                                class: "ml-2 block text-gray-700"
                              }, _toDisplayString(day.value), 9, ["for"])
                            ]))
                          }), 128))
                        ])
                      ]),
                      default: _withId(() => [
                        _hoisted_38,
                        _hoisted_39
                      ]),
                      _: 1
                    }, 8, ["active", "prevent-click", "onShowModal"]),
                    _createVNode(_component_m_table_condition_item, {
                      class: "hidden lg:block",
                      active: _ctx.learningTerm !== '過去7日間' && !_ctx.isFilterDisabled,
                      "prevent-click": _ctx.isFilterDisabled,
                      "display-alert-on-prevention": "",
                      alert: "全ての生徒情報の取得が完了するまでお待ちください。",
                      onShowModal: _ctx.handleShowModalChange
                    }, {
                      body: _withId(() => [
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.learningTerms, (term) => {
                            return (_openBlock(), _createBlock("li", {
                              key: term.id,
                              class: ["list-none flex items-center w-full px-4 py-2 text-gray-700 cursor-pointer transition-all duration-300 hover:bg-gray-100 hover:text-primary-600", {
                        'text-gray-700': term.value != _ctx.learningTerm,
                        'text-primary-500': term.value == _ctx.learningTerm
                      }],
                              onClick: ($event: any) => (_ctx.changeLearningTerm(term.value))
                            }, _toDisplayString(term.value), 11, ["onClick"]))
                          }), 128))
                        ]),
                        _createVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _createVNode(_component_m_text_field, {
                            name: "termStart",
                            type: "date",
                            placeholder: "2021/04/01",
                            value: _ctx.termStart,
                            entered: "",
                            class: "flex-1",
                            onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changeTermStart($event)))
                          }, null, 8, ["value"])
                        ]),
                        _createVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createVNode(_component_m_text_field, {
                            name: "termEnd",
                            type: "date",
                            placeholder: "2021/04/01",
                            value: _ctx.termEnd,
                            entered: "",
                            class: "flex-1",
                            onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.changeTermEnd($event)))
                          }, null, 8, ["value"])
                        ]),
                        _createVNode("div", _hoisted_47, [
                          _createVNode(_component_m_button, {
                            color: "secondary-500",
                            outline: "",
                            size: "sm",
                            onClick: _ctx.updateLearningTerms
                          }, {
                            default: _withId(() => [
                              _hoisted_48
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      default: _withId(() => [
                        _createVNode("span", null, "対象期間: " + _toDisplayString(_ctx.learningTerm), 1),
                        _hoisted_42
                      ]),
                      _: 1
                    }, 8, ["active", "prevent-click", "onShowModal"]),
                    _createVNode(_component_m_table_condition_item, {
                      active: 
                  _ctx.selectedColumnList?.length !== _ctx.columnList.length &&
                    !_ctx.isFilterDisabled
                ,
                      "prevent-click": _ctx.isFilterDisabled,
                      "display-alert-on-prevention": "",
                      alert: "全ての生徒情報の取得が完了するまでお待ちください。",
                      class: "hidden lg:block",
                      onShowModal: _ctx.handleShowModalChange
                    }, {
                      body: _withId(() => [
                        _createVNode("ul", null, [
                          _createVNode("li", {
                            class: ["list-none flex items-center w-full px-2 py-2 text-sm font-bold border-b", { 'mt-4': !_ctx.isAdmin }]
                          }, [
                            _hoisted_51,
                            _createVNode("button", {
                              class: "ml-24 bg-blue-400 hover:bg-blue-500 text-white p-1 rounded text-xs",
                              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.selectAllColumn && _ctx.selectAllColumn(...args)))
                            }, " 全選択 "),
                            _createVNode("button", {
                              class: "ml-2 bg-gray-400 hover:bg-gray-500 text-white p-1 rounded text-xs",
                              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.deselectAllColumn && _ctx.deselectAllColumn(...args)))
                            }, " 全解除 ")
                          ], 2),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (column) => {
                            return (_openBlock(), _createBlock("li", {
                              key: column.id,
                              class: "list-none flex items-center w-full px-4 py-2 text-sm"
                            }, [
                              _withDirectives(_createVNode("input", {
                                id: `${column.id}`,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.selectedColumnList = $event)),
                                type: "checkbox",
                                value: column.id,
                                class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                              }, null, 8, ["id", "value"]), [
                                [_vModelCheckbox, _ctx.selectedColumnList]
                              ]),
                              _createVNode("label", {
                                for: `${column.id}`,
                                class: "ml-2 block text-gray-700 w-44 truncate"
                              }, _toDisplayString(column.value), 9, ["for"])
                            ]))
                          }), 128))
                        ])
                      ]),
                      default: _withId(() => [
                        _hoisted_49,
                        _hoisted_50
                      ]),
                      _: 1
                    }, 8, ["active", "prevent-click", "onShowModal"]),
                    _createVNode(_component_m_table_condition_item, {
                      "prevent-click": _ctx.isFilterDisabled,
                      "display-alert-on-prevention": "",
                      alert: "全ての生徒情報の取得が完了するまでお待ちください。",
                      class: "hidden lg:block",
                      onShowModal: _ctx.handleShowModalChange
                    }, {
                      body: _withId(() => [
                        _createVNode("ul", null, [
                          _createVNode("li", {
                            class: ["list-none flex flex-col justify-items-center w-full px-2 py-2 text-sm font-bold border-b", { 'mt-4': !_ctx.isAdmin }]
                          }, [
                            _hoisted_54,
                            _hoisted_55,
                            _createVNode("div", _hoisted_56, [
                              _createVNode("label", _hoisted_57, [
                                _hoisted_58,
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.isOrderDesc = $event)),
                                  type: "checkbox",
                                  onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleOrderAscChange($event)))
                                }, null, 544), [
                                  [_vModelCheckbox, _ctx.isOrderDesc]
                                ])
                              ])
                            ])
                          ], 2),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderKeyList, (orderKey) => {
                            return (_openBlock(), _createBlock("li", {
                              key: orderKey.keyName,
                              class: "list-none flex items-center w-full px-4 py-2 text-sm"
                            }, [
                              _createVNode("input", {
                                id: `${orderKey.keyName}`,
                                type: "checkbox",
                                value: orderKey.keyName,
                                checked: _ctx.selectedOrderKey === orderKey.keyName,
                                class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                                onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleOrderKeySelectionChange($event)))
                              }, null, 40, ["id", "value", "checked"]),
                              _createVNode("label", {
                                for: `${orderKey.keyName}`,
                                class: "ml-2 block text-gray-700 w-44 truncate"
                              }, _toDisplayString(orderKey.displayName), 9, ["for"])
                            ]))
                          }), 128))
                        ])
                      ]),
                      default: _withId(() => [
                        _hoisted_52,
                        _hoisted_53
                      ]),
                      _: 1
                    }, 8, ["prevent-click", "onShowModal"]),
                    _createVNode(_component_m_button, {
                      color: "gray-500",
                      text: "",
                      class: "mr-1",
                      disabled: _ctx.isStudentListRefreshing,
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (
                  _ctx.getLatestData({ override: true, refreshStudentCount: true })
                ))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_m_icon, {
                          type: "refresh",
                          class: "mr-2"
                        }),
                        _hoisted_59
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ], 2),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock("div", _hoisted_60, [
                      _createVNode(_component_MLoadingIcon),
                      _hoisted_61
                    ]))
                  : (_openBlock(), _createBlock(_component_m_table, {
                      key: 1,
                      datas: _ctx.filteredDatas,
                      definitions: _ctx.definitions,
                      "count-per-page": 40,
                      "selected-column-list": _ctx.selectedColumnList,
                      "padding-top": 12,
                      order: "",
                      selectable: "",
                      "filterable-column": "",
                      "selected-ids": _ctx.selectedIds,
                      "disable-selection": !_ctx.allStudentsFetched,
                      onChange: _ctx.changeSelectedId
                    }, {
                      footer: _withId(() => [
                        _createVNode("div", null, [
                          _createVNode("div", _hoisted_62, [
                            _createVNode("div", _hoisted_63, [
                              _createVNode("p", _hoisted_64, _toDisplayString(_ctx.selectedIds.length) + "人選択中 ", 1),
                              _createVNode(_component_m_action_dropdown, {
                                title: "選択中の生徒に実行",
                                disabled: _ctx.selectedIds.length == 0,
                                "condition-modal-showing": _ctx.isMConditionModalShowing,
                                "dropdown-direction": "up",
                                class: "mr-6",
                                onOnModalOpened: _ctx.handleMultiDropDownOpened
                              }, {
                                default: _withId(() => [
                                  (!_ctx.isAdmin)
                                    ? (_openBlock(), _createBlock(_component_m_dropdown_item, {
                                        key: 0,
                                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.moveToPrint('mingaku')))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_65
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (!_ctx.isAdmin)
                                    ? (_openBlock(), _createBlock(_component_m_dropdown_item, {
                                        key: 1,
                                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.moveToPrint('schoolAI')))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_66
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (!_ctx.isAdmin)
                                    ? (_openBlock(), _createBlock(_component_m_dropdown_item, {
                                        key: 2,
                                        onClick: _ctx.exportToCsv
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_67
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_m_dropdown_item, { onClick: _ctx.exportStudent }, {
                                    default: _withId(() => [
                                      _hoisted_68
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_m_dropdown_item, { onClick: _ctx.exportTodoToCsv }, {
                                    default: _withId(() => [
                                      _hoisted_69
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_m_dropdown_item, {
                                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.exportJournalRecords({ exportAll: false })))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_70
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_m_dropdown_item, { onClick: _ctx.exportLearningCard }, {
                                    default: _withId(() => [
                                      _hoisted_71
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_m_dropdown_item, {
                                    onClick: _cache[29] || (_cache[29] = ($event: any) => (
                          _ctx.updatePromptCreationPermission({
                            promptCreationAllowed: true,
                            target: 'selected'
                          })
                        ))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_72
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_m_dropdown_item, {
                                    onClick: _cache[30] || (_cache[30] = ($event: any) => (
                          _ctx.updatePromptCreationPermission({
                            promptCreationAllowed: false,
                            target: 'selected'
                          })
                        ))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_73
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_m_dropdown_item, {
                                    onClick: _cache[31] || (_cache[31] = ($event: any) => (
                          _ctx.updateMessageSendingPermission({
                            messageSendingAllowed: true,
                            target: 'selected'
                          })
                        ))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_74
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_m_dropdown_item, {
                                    onClick: _cache[32] || (_cache[32] = ($event: any) => (
                          _ctx.updateMessageSendingPermission({
                            messageSendingAllowed: false,
                            target: 'selected'
                          })
                        ))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_75
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_m_dropdown_item, {
                                    onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.isDisplayedAddGroupModal = true))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_76
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_m_dropdown_item, { onClick: _ctx.showReservationModal }, {
                                    default: _withId(() => [
                                      _hoisted_77
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_m_dropdown_item, { onClick: _ctx.showSendModalWithDefaultStudents }, {
                                    default: _withId(() => [
                                      _hoisted_78
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  (_ctx.canEditStudent)
                                    ? (_openBlock(), _createBlock(_component_m_dropdown_item, {
                                        key: 3,
                                        onClick: _ctx.setStudentsRecess
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_79
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.canEditStudent)
                                    ? (_openBlock(), _createBlock(_component_m_dropdown_item, {
                                        key: 4,
                                        onClick: _ctx.cancelStudentsRecess
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_80
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.canEditStudent)
                                    ? (_openBlock(), _createBlock(_component_m_dropdown_item, {
                                        key: 5,
                                        "has-border": false,
                                        onClick: _ctx.deleteStudents
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_81
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["disabled", "condition-modal-showing", "onOnModalOpened"]),
                              (_ctx.isAdminOfSchool)
                                ? (_openBlock(), _createBlock(_component_m_action_dropdown, {
                                    key: 0,
                                    title: "全生徒に実行",
                                    "condition-modal-showing": _ctx.isMConditionModalShowing,
                                    "dropdown-direction": "up",
                                    onOnModalOpened: _ctx.handleMultiDropDownOpened
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_m_dropdown_item, {
                                        disabled: !_ctx.allStudentsFetched,
                                        onClick: _cache[34] || (_cache[34] = ($event: any) => (
                          _ctx.updatePromptCreationPermission({
                            promptCreationAllowed: true,
                            target: 'all'
                          })
                        ))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_82
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(_component_m_dropdown_item, {
                                        disabled: !_ctx.allStudentsFetched,
                                        onClick: _cache[35] || (_cache[35] = ($event: any) => (
                          _ctx.updatePromptCreationPermission({
                            promptCreationAllowed: false,
                            target: 'all'
                          })
                        ))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_83
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(_component_m_dropdown_item, {
                                        disabled: !_ctx.allStudentsFetched,
                                        onClick: _cache[36] || (_cache[36] = ($event: any) => (
                          _ctx.updateMessageSendingPermission({
                            messageSendingAllowed: true,
                            target: 'all'
                          })
                        ))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_84
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(_component_m_dropdown_item, {
                                        disabled: !_ctx.allStudentsFetched,
                                        onClick: _cache[37] || (_cache[37] = ($event: any) => (
                          _ctx.updateMessageSendingPermission({
                            messageSendingAllowed: false,
                            target: 'all'
                          })
                        ))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_85
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(_component_m_dropdown_item, {
                                        disabled: !_ctx.allStudentsFetched,
                                        onClick: _ctx.moveUpGrade
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_86
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "onClick"]),
                                      _createVNode(_component_m_dropdown_item, {
                                        disabled: !_ctx.allStudentsFetched,
                                        onClick: _ctx.moveDownGrade
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_87
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "onClick"]),
                                      _createVNode(_component_m_dropdown_item, {
                                        disabled: !_ctx.allStudentsFetched,
                                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.moveToPrint('mingaku', { printAll: true })))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_88
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(_component_m_dropdown_item, {
                                        disabled: !_ctx.allStudentsFetched,
                                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.moveToPrint('schoolAI', { printAll: true })))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_89
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(_component_m_dropdown_item, {
                                        "has-border": false,
                                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.exportJournalRecords({ exportAll: true })))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_90
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["condition-modal-showing", "onOnModalOpened"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["datas", "definitions", "selected-column-list", "selected-ids", "disable-selection", "onChange"]))
              ])
            ])
          ])
        ]),
        (_ctx.isDisplayedAddStudentModal)
          ? (_openBlock(), _createBlock(_component_m_s_add_modal, {
              key: 0,
              classrooms: _ctx.classrooms,
              "custom-properties": _ctx.customProperties,
              onClose: _ctx.closeAddModal
            }, null, 8, ["classrooms", "custom-properties", "onClose"]))
          : _createCommentVNode("", true),
        (_ctx.isDisplayedSendModal)
          ? (_openBlock(), _createBlock(_component_ms_send_modal, {
              key: 1,
              schools: 
      _ctx.schools.sort((a, b) => {
        return a.data.name < b.data.name ? -1 : 1;
      })
    ,
              classrooms: 
      _ctx.classrooms.sort((a, b) => {
        return a.data.name < b.data.name ? -1 : 1;
      })
    ,
              students: _ctx.students,
              groups: _ctx.groups,
              "default-student-ids": _ctx.withDefaultStudents ? _ctx.selectedIds : [],
              onClose: _ctx.closeSendModal
            }, null, 8, ["schools", "classrooms", "students", "groups", "default-student-ids", "onClose"]))
          : _createCommentVNode("", true),
        (_ctx.isDisplayedAddGroupModal)
          ? (_openBlock(), _createBlock(_component_ms_add_group_modal, {
              key: 2,
              "custom-properties": _ctx.customProperties,
              "default-student-ids": _ctx.selectedIds,
              onClose: _cache[41] || (_cache[41] = ($event: any) => (_ctx.isDisplayedAddGroupModal = false))
            }, null, 8, ["custom-properties", "default-student-ids"]))
          : _createCommentVNode("", true),
        (_ctx.isDisplayedReservationModal)
          ? (_openBlock(), _createBlock(_component_ms_reserve_modal, {
              key: 3,
              "use-picker": true,
              "default-student-ids": _ctx.selectedStudents.map(s => s.ref.id),
              onClose: _cache[42] || (_cache[42] = ($event: any) => (_ctx.isDisplayedReservationModal = false))
            }, null, 8, ["default-student-ids"]))
          : _createCommentVNode("", true),
        (_ctx.isCsvUpdateModalOpen)
          ? (_openBlock(), _createBlock(_component_ms_csv_update_modal, {
              key: 4,
              type: "studentsUpdate",
              onClose: _cache[43] || (_cache[43] = ($event: any) => (_ctx.isCsvUpdateModalOpen = false)),
              onClickFileInputRef: _ctx.clickFileInputRef,
              onExportAllStudents: _cache[44] || (_cache[44] = ($event: any) => (_ctx.exportStudent({ exportAll: true, onlyTemplate: false })))
            }, null, 8, ["onClickFileInputRef"]))
          : _createCommentVNode("", true),
        (_ctx.isGoogleLinkageModalOpen)
          ? (_openBlock(), _createBlock(_component_ms_csv_update_modal, {
              key: 5,
              type: "googleLinkage",
              onClose: _cache[45] || (_cache[45] = ($event: any) => (_ctx.isGoogleLinkageModalOpen = false)),
              onExportGoogleTemplate: _cache[46] || (_cache[46] = ($event: any) => (
      _ctx.exportCsvTemplateForExternalProviderLinkage('google')
    )),
              onStartGoogleUpdating: _ctx.startLinkingGoogle
            }, null, 8, ["onStartGoogleUpdating"]))
          : _createCommentVNode("", true),
        (_ctx.isMicrosoftLinkageModalOpen)
          ? (_openBlock(), _createBlock(_component_ms_csv_update_modal, {
              key: 6,
              type: "microsoftLinkage",
              onClose: _cache[47] || (_cache[47] = ($event: any) => (_ctx.isMicrosoftLinkageModalOpen = false)),
              onExportMicrosoftTemplate: _cache[48] || (_cache[48] = ($event: any) => (
      _ctx.exportCsvTemplateForExternalProviderLinkage('microsoft')
    )),
              onStartMicrosoftUpdating: _ctx.startLinkingMicrosoft
            }, null, 8, ["onStartMicrosoftUpdating"]))
          : _createCommentVNode("", true),
        (_ctx.isMultiStudentRegistrationModal)
          ? (_openBlock(), _createBlock(_component_ms_csv_update_modal, {
              key: 7,
              type: "studentsRegister",
              onClose: _cache[49] || (_cache[49] = ($event: any) => (_ctx.isMultiStudentRegistrationModal = false)),
              onExportMultiStudentRegistrationTemplate: _ctx.downloadCsvTemplate,
              onStartMultiStudentRegistration: _ctx.startMultiStudentRegistration
            }, null, 8, ["onExportMultiStudentRegistrationTemplate", "onStartMultiStudentRegistration"]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createBlock("div", _hoisted_91, [
        _createVNode(_component_MNavBar),
        _createVNode("div", _hoisted_92, [
          _createVNode(_component_MHeaderPanel, {
            title: "",
            breadcrumbs: []
          }),
          _createVNode("main", _hoisted_93, [
            _createVNode("section", _hoisted_94, [
              _hoisted_95,
              _hoisted_96,
              _createVNode("div", _hoisted_97, [
                _createVNode("a", {
                  href: _ctx.newAccountManagementUrl,
                  class: "inline-flex items-center rounded-md font-medium text-sm transition-all duration-300 px-4 py-2 text-white bg-primary-500 hover:bg-primary-600 cursor-pointer"
                }, " 新しい生徒一覧画面を開く ", 8, ["href"])
              ])
            ])
          ])
        ])
      ]))
})